import type { BrandJson } from "@coras-io/brand-tokens";
import {
  DEFAULT_CURRENCIES,
  DEFAULT_LOCALES,
  type SiteConfig,
} from "../../src/types";
import brandConfig from "./brand.json";

// The Turkish Pegasus site: same brand and Coras distributor as `pegasus`, but a
// separate hostname and a tr-TR default with detection off.
export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "b749451e-3acd-4d0a-9fb9-621ed549ee46",
  title: "Pegasus",
  description: "Book tickets to West End Shows, Concerts and more",
  locale: "tr-TR",
  currency: "TRY",
  locales: DEFAULT_LOCALES,
  currencies: DEFAULT_CURRENCIES,
  favicons: [
    "apple-touch-icon-180x180.png",
    "favicon-16x16.png",
    "favicon-32x32.png",
    "favicon.ico",
  ],
  logo: "/assets/images/logo.svg",
  domain: "turveaktiviteler.flypgs.com",
  detectLocale: false,
  detectCurrency: false,
};
